// extracted by mini-css-extract-plugin
module.exports = {"inviteBtnCustom":"networks_inviteBtnCustom__18wGD"};